// ============================================================================
// HEBREW TRANSLATIONS - CHAPTER 4: הצליבה והתחייה
// ============================================================================
// רמות 40-52 (13 רמות, 39 שאלות)

export const chapter4Translations = {
  name: "הצליבה והתחייה",
  description: "הוא קם!",
  
  spiritualWisdom: {
    principle: "במותו ובתחייתו, ישוע מעניק לנו חיי עולם",
    scripture: "אָנֹכִי הַתְּחִיָּה וְהַחַיִּים. הַמַּאֲמִין בִּי אַף כִּי יָמוּת יִחְיֶה (יוחנן 11:25)",
    application: "הצליבה והקבר הריק הם לב אמונתנו ומקור תקוותנו"
  },
  
  levels: {
    40: {
      name: "המעצר",
      challenge: "יְהוּדָה, הַבִּנְשִׁיקָה אַתָּה מוֹסֵר אֶת בֶּן הָאָדָם?",
      easy: {
        question: "מי בגד בישוע?",
        options: ["פטרוס", "יהודה", "תומא", "מתי"],
        hint: "אחד משנים העשר תלמידים",
        funFact: "💔 יהודה מכר את ישוע ב-30 מטבעות כסף - מחיר עבד!"
      },
      medium: {
        question: "איזה סימן השתמש יהודה כדי לזהות את ישוע?",
        options: [
          "הצביע עליו",
          "קרא לו בשמו",
          "נשק לו",
          "הראה אותו לחיילים"
        ],
        hint: "מחווה של חיבה שעוותה",
        funFact: "😢 הנשיקה, סמל אהבה, הופכת לכלי בגידה!"
      },
      hard: {
        question: "איך הגיב ישוע לבגידה ולמעצר?",
        options: [
          "הגן על עצמו באלימות",
          "ברח",
          "קיבל בכבוד וריפא את אוזן העבד",
          "קילל את אויביו"
        ],
        hint: "הראה אהבה אפילו לאויביו",
        funFact: "✨ אפילו במעצר, ישוע ריפא את אוזנו הכרותה של מלכוס!"
      }
    },
    
    41: {
      name: "הכחשת פטרוס",
      challenge: "בְּטֶרֶם יִקְרָא הַתַּרְנְגוֹל תְּכַחֵשׁ בִּי שָׁלוֹשׁ פְּעָמִים...",
      easy: {
        question: "כמה פעמים פטרוס הכחיש את ישוע?",
        options: ["פעם אחת", "פעמיים", "3 פעמים", "4 פעמים"],
        hint: "המספר שישוע ניבא",
        funFact: "🐓 קריאת התרנגול הזכירה לפטרוס את נבואת ישוע!"
      },
      medium: {
        question: "איפה היה פטרוס כשהכחיש את ישוע?",
        options: [
          "במקדש",
          "אצל פילטוס",
          "בחצר הכהן הגדול",
          "בדרך"
        ],
        hint: "הוא עקב אחרי ישוע מרחוק",
        funFact: "🔥 פטרוס התחמם ליד האש עם אויבי ישוע!"
      },
      hard: {
        question: "מה מלמדת אותנו השבת פטרוס אחרי הכחשתו?",
        options: [
          "יש חטאים שאינם נסלחים",
          "אהבתו של ישוע מקימה אפילו את נפילותינו הגדולות ביותר",
          "פטרוס היה לא ראוי",
          "צריך להסתיר את הטעויות שלנו"
        ],
        hint: "מדובר בחסד שמשקם",
        funFact: "💝 ישוע שואל 3 פעמים 'האם אתה אוהב אותי?' כדי לשקם את 3 ההכחשות!"
      }
    },

    42: {
      name: "ישוע לפני פילטוס",
      challenge: "הַאַתָּה מֶלֶךְ הַיְּהוּדִים? אַתָּה אֹמֵר...",
      easy: {
        question: "מי היה המושל הרומי ששפט את ישוע?",
        options: ["קיסר", "פילטוס", "הורדוס", "אנטוניוס"],
        hint: "נציג רומא ביהודה",
        funFact: "⚖️ פילטוס מכיר בחפותו של ישוע אך מרשיע אותו מפחדנות!"
      },
      medium: {
        question: "איזה מנהג הציע פילטוס להשתמש בו?",
        options: [
          "לשחרר אסיר בפסח",
          "לדחות את המשפט",
          "לערער לקיסר",
          "להגלות את ישוע"
        ],
        hint: "מסורת פסח",
        funFact: "🔓 פילטוס קיווה לשחרר את ישוע בזכות מנהג הפסח הזה!"
      },
      hard: {
        question: "מה מגלה יחסו של פילטוס על צדק אנושי?",
        options: [
          "צדק תמיד מתגשם",
          "לחץ עממי יכול להשחית אפילו את הצדק",
          "פילטוס היה רשע",
          "פוליטיקה גוברת על אמת"
        ],
        hint: "מדובר בחולשה מול ההמון",
        funFact: "💧 פילטוס רוחץ את ידיו אך נשאר אחראי לעוול!"
      }
    }
  }
};

export default chapter4Translations;
